import { Component, Input } from '@angular/core';

import Chart from 'chart.js';
import { EMMAChartBase } from './emma-chart-base';
import { getConfig } from './emma-quickstat.component.helpers';

declare const mUtil: any;

interface Data {
  labels: string[];
  values: { [k: string]: number };
  variation?: number;
  total?: number;
  error?: Error;
  loading?: boolean;
}

@Component({
    selector: 'emma-quickstat',
    templateUrl: './emma-chart.template.html',
    standalone: false
})
export class EMMAQuickstatComponent extends EMMAChartBase {
  @Input()
  override color!: 'altgreen' | 'altpink' | 'altblue' | 'altorange' | 'altyellow' | 'altviolet' | string;

  data: Data = { labels: [], values: {} };

  override init() {
    const el = document.getElementById(this.chartId) as HTMLCanvasElement;
    if (!el) {
      throw new Error('Chart not found: ' + this.chartId);
    }
    const ctx = el.getContext('2d');
    if (!ctx) {
      throw new Error('Chart without Context2D: ' + this.chartId);
    }
    const config: any = getConfig();

    this.chart = new Chart(ctx, config);
    this.chartLoad.emit(true);
    if (this.export) {
      this.export.subscribe(() => this.exportChart());
    }
  }

  override getStyle = () => this.color;

  protected override _updateChart() {
    if (!this.chart) {
      return;
    }
    const dataset = {
      label: [this.chartTitle || ''],
      borderColor: mUtil.getColor(this.color),
      borderWidth: 3,
      pointHoverRadius: 4,
      pointHoverBorderWidth: 12,
      pointBackgroundColor: 'rgba(0,0,0,0)',
      pointBorderColor: 'rgba(0,0,0,0)',
      pointHoverBackgroundColor: mUtil.getColor('danger'),
      pointHoverBorderColor: 'rgba(0,0,0,0)',
      fill: false,
      data: this.data.labels.map((label) => this.data.values[label] || 0),
    };
    this.chart.data.labels = this.data.labels;
    this.chart.data.datasets = [dataset];
    this.chart.update();
  }

  override update(data: Data | null) {
    if (data && data.error) {
      return this.error(data.error);
    } else if (!data || data.loading) {
      return this.loading();
    }
    this.loaded();
    this.data = data;
    let total: number;
    if (typeof data.total === 'number') {
      total = data.total;
    } else {
      total = data.labels.reduce((acc, label) => acc + (data.values[label] || 0), 0);
    }
    this.updateTotal(total);
    this._updateChart();
  }
}
